import { TooltipPositionProvider } from '../context/TooltipPositionContext';
import { useBoundingRects } from '../hooks/useBoundingRects';
import Tooltip, { defaultStyles } from './Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
function TooltipWithBounds(_ref) {
  let {
    children,
    left: initialLeft = 0,
    offsetLeft = 2,
    offsetTop = 2,
    style = defaultStyles,
    top: initialTop = 0,
    unstyled = false,
    ...otherProps
  } = _ref;
  let transform;
  let placeTooltipLeft = false;
  let placeTooltipUp = true;
  const {
    nodeRef,
    rect: ownBounds,
    parentRect: parentBounds
  } = useBoundingRects();
  if (ownBounds && parentBounds) {
    let left = initialLeft;
    let top = initialTop;
    if (parentBounds.width) {
      const rightPlacementClippedPx = left + offsetLeft + ownBounds.width - parentBounds.width;
      const leftPlacementClippedPx = ownBounds.width - left - offsetLeft;
      placeTooltipLeft = rightPlacementClippedPx > 0 && rightPlacementClippedPx > leftPlacementClippedPx;
    } else {
      const rightPlacementClippedPx = left + offsetLeft + ownBounds.width - window.innerWidth;
      const leftPlacementClippedPx = ownBounds.width - left - offsetLeft;
      placeTooltipLeft = rightPlacementClippedPx > 0 && rightPlacementClippedPx > leftPlacementClippedPx;
    }
    if (parentBounds.height) {
      const bottomPlacementClippedPx = top + offsetTop + ownBounds.height - parentBounds.height;
      const topPlacementClippedPx = ownBounds.height - top - offsetTop;
      placeTooltipUp = !(topPlacementClippedPx > 0) && bottomPlacementClippedPx < topPlacementClippedPx;
    } else {
      placeTooltipUp = top + offsetTop + ownBounds.height > window.innerHeight;
    }
    left = placeTooltipLeft ? left - ownBounds.width - offsetLeft : left + offsetLeft;
    top = placeTooltipUp ? top - ownBounds.height - offsetTop : top + offsetTop;
    left = Math.round(left);
    top = Math.round(top);
    transform = `translate(${left}px, ${top}px)`;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    ref: nodeRef,
    style: {
      left: 0,
      top: 0,
      transform,
      ...(!unstyled && style)
    },
    ...otherProps,
    children: /*#__PURE__*/_jsx(TooltipPositionProvider, {
      value: {
        isFlippedVertically: !placeTooltipUp,
        isFlippedHorizontally: !placeTooltipLeft
      },
      children: children
    })
  });
}
export default TooltipWithBounds;